import addBaseLayoutHandler from "./BaseLayout/Layout";
import OrdersCreatePage from "./Orders/Create/CreateOrder";
import OrdersOverview from "./Orders/Overview/OrdersOverview";
import UsersPage from "./Users/Users";
import StoresPage from "./Stores/Stores";
import ServicesPage from "./Services/Services";
import ItemsPage from "./Items/Items";
import ChangeLanguage from "./BaseLayout/ChangeLanguage";

let url = window.location.pathname.toLowerCase();

addBaseLayoutHandler(url);
new ChangeLanguage();

if (url === "/" || url === "/orders" || url.includes("/orders/create")) {
	new OrdersCreatePage();
}

if (url.includes('/orders/index')) {
	new OrdersOverview();
}

if (url.includes("/users")) {
	new UsersPage();
}

if (url.includes("/domainadmin/stores")) {
	new StoresPage();
}

if (url.includes("domainadmin/services")) {
	new ServicesPage();
}

if (url.includes("domainadmin/items")) {
	new ItemsPage();
}
